<script setup lang="ts">
import BaseHeader from '@/components/BaseHeader.vue';
import BaseFooter from '@/components/BaseFooter.vue';
import CookieAgreement from '@/components/common/CookieAgreement.vue';
import Maintenance from '@/views/Maintenance.vue';

const isMaintenanceMode = process.env.VUE_APP_MAINTENANCE_MODE === 'true';
console.log(isMaintenanceMode);
</script>

<template>
    <Maintenance v-if="isMaintenanceMode" />

    <div
        v-else
        class="tailwind-root app-root"
        style="min-height: 100vh"
    >
        <BaseHeader />

        <router-view />

        <BaseFooter />

        <CookieAgreement />
    </div>
</template>

<style scoped>
.app-root {
    @apply flex flex-col relative;
}
</style>
